import { useTranslation } from "react-i18next";

import { IoMdArrowBack } from "react-icons/io";
import { IoClose } from "react-icons/io5";

import { useNavigate } from "react-router-dom";
import FloatingMenu from "../components/FloatingMenu";
import { assetPath } from "../utils/assets";

const AboutUs = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const TELEGRAM_URL = "";
    // const TELEGRAM_URL = "https://t.me/poseidon33_livechat";
    const handleLinkClick = () => window.open(TELEGRAM_URL, "_blank");

    const paragraphs = [
        "aboutUsParagraph1",
        "aboutUsParagraph2",
        "aboutUsParagraph3"
    ];

    const footerTexts = ["aboutUsText1", "aboutUsText2"];

    return (
        <section className="page-shell">
            <div className="page-header">
                <div
                    className="cursor-pointer bg-secondary container-back-button text-color-blue rounded-full"
                    onClick={() => navigate("/")}
                >
                    <IoMdArrowBack className="size-sm" />
                    <span className="text-sm">
                        {t("backToLobby")}
                    </span>
                </div>
                <button className="cursor-pointer" onClick={() => navigate("/")}>
                    <IoClose className="size-lg text-color-blue" />
                </button>
            </div>

            <div className="px-4 pt-7">
                <p className="page-title">
                    {t("aboutUs")}
                </p>

                <div className="flex flex-col gap-6">
                    {paragraphs.map((key) => (
                        <p key={key} className="text-body">
                            {t(key)}
                        </p>
                    ))}

                    {[1, 2].map((num) => (
                        <div key={num}>
                            <p className="text-body">
                                {t(`aboutUsJoinUs${num}`)}
                            </p>
                            <button 
                                onClick={handleLinkClick}
                                className="text-sm text-button-blue hover:underline text-left break-all"
                            >
                                {TELEGRAM_URL}
                            </button>
                        </div>
                    ))}

                    {footerTexts.map((key) => (
                        <p key={key} className="text-body">
                            {t(key)}
                        </p>
                    ))}
                </div>

                <div className="py-8">
                    <div className="flex-between gap-2">
                        {[1, 2, 3, 4].map((num) => (
                            <img 
                                key={num}
                                src={assetPath(`/icons/logo${num}.png`)}
                                alt={`License ${num}`} 
                                className="h-7 w-auto object-contain" 
                            />
                        ))}
                    </div>
                </div>
            </div>
            <FloatingMenu />
        </section>
    );
};

export default AboutUs;